import React from 'react';
import { Box, Typography, Grid, FormControl, InputLabel, Select, MenuItem, TextField, Button } from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import { useDistributedQueueTracker } from '../DistributedQueueTrackerProvider';

export function FilterForm({ filterOptions, handleUpdate }) {
  const { setFilters, parametros, resetFilter } = useDistributedQueueTracker();
  const {
    process,
    templateName,
    channel,
    status,
    updatedAtStart,
    updatedAtEnd,
    consumerUnitCode,
    createdAtStart,
    createdAtEnd,
  } = parametros?.filter || {};
  const { statuses, channels, templateNames, processes } = filterOptions || {};
  const { control, handleSubmit, setValue, reset } = useForm({
    defaultValues: {
      process: process || '',
      templateName: templateName || '',
      channel: channel || '',
      status: status || '',
      updatedAtStart: updatedAtStart || null,
      updatedAtEnd: updatedAtEnd || null,
      createdAtStart: createdAtStart || null,
      createdAtEnd: createdAtEnd || null,
      consumerUnitCode: consumerUnitCode || '',
    },
  });

  const handleReset = () => {
    reset();
    resetFilter();
  };

  const onSubmit = data => {
    const filters = {
      process: data.process === 'all' ? '' : data.process,
      templateName: data.templateName === 'all' ? '' : data.templateName,
      channel: data.channel === 'all' ? '' : data.channel,
      status: data.status === 'all' ? '' : data.status,
      updatedAtStart: data.updatedAtStart,
      updatedAtEnd: data.updatedAtEnd,
      createdAtStart: data.createdAtStart,
      createdAtEnd: data.createdAtEnd,
      consumerUnitCode: data.consumerUnitCode,
    };

    setFilters(filters);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Filtros
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          {/* Filtro de Processo */}
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <InputLabel>Processo</InputLabel>
              <Controller
                name="process"
                control={control}
                render={({ field }) => (
                  <Select {...field} label="Processo">
                    <MenuItem value="all">Selecionar Todos</MenuItem>
                    {processes.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <InputLabel>Nome do Template</InputLabel>
              <Controller
                name="templateName"
                control={control}
                render={({ field }) => (
                  <Select {...field} label="Nome do Template">
                    <MenuItem value="all">Selecionar Todos</MenuItem>
                    {templateNames.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <InputLabel>Canal</InputLabel>
              <Controller
                name="channel"
                control={control}
                render={({ field }) => (
                  <Select {...field} label="Canal">
                    <MenuItem value="all">Selecionar Todos</MenuItem>
                    {channels.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Controller
                name="status"
                control={control}
                render={({ field }) => (
                  <Select {...field} label="Status">
                    <MenuItem value="all">Selecionar Todos</MenuItem>
                    {statuses.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Controller
              name="consumerUnitCode"
              control={control}
              render={({ field: { value, ref, onChange } }) => (
                <TextField
                  onChange={onChange}
                  inputRef={ref}
                  value={value}
                  label="Código Unidade Consumidora"
                  fullWidth
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Controller
              name="updatedAtStart"
              control={control}
              render={({ field: { value } }) => (
                <DatePicker
                  style={{ width: '100%' }}
                  value={value}
                  format="dd/MM/yyyy"
                  label="Data Inicial de Atualização"
                  onChange={date => setValue('updatedAtStart', date.startOf('day').toISO())}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Controller
              name="updatedAtEnd"
              control={control}
              render={({ field: { value } }) => (
                <DatePicker
                  style={{ width: '100%' }}
                  value={value}
                  format="dd/MM/yyyy"
                  label="Data Final de Atualização"
                  onChange={date => setValue('updatedAtEnd', date.endOf('day').toISO())}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Controller
              name="createdAtStart"
              control={control}
              render={({ field: { value } }) => (
                <DatePicker
                  style={{ width: '100%' }}
                  value={value}
                  format="dd/MM/yyyy"
                  label="Data Inicial de Criação"
                  onChange={date => setValue('createdAtStart', date.startOf('day').toISO())}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Controller
              name="createdAtEnd"
              control={control}
              render={({ field: { value } }) => (
                <DatePicker
                  style={{ width: '100%' }}
                  value={value}
                  format="dd/MM/yyyy"
                  label="Data Final de Criação"
                  onChange={date => setValue('createdAtEnd', date.endOf('day').toISO())}
                />
              )}
            />
          </Grid>
          <Grid container justifyContent="flex-end" spacing={2} style={{ marginTop: 10 }}>
            <Grid item>
              <Button variant="contained" color="primary" onClick={handleUpdate}>
                ATUALIZAR
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" color="primary" type="submit">
                APLICAR FILTROS
              </Button>
            </Grid>
            <Grid item>
              <Button color="primary" onClick={handleReset}>
                LIMPAR FILTROS
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}

FilterForm.propTypes = {
  filterOptions: PropTypes.shape({
    statuses: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      }),
    ).isRequired,
    channels: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      }),
    ).isRequired,
    templateNames: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      }),
    ).isRequired,
    processes: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default FilterForm;
